export default [
  {
    path: '/yyzx',
    component: () => import('./views/index')
  }
]



// WEBPACK FOOTER //
// ./src/page/yyzx/router.js